export default __webpack_public_path__ + "static/media/logo-mobile-nav-efefef.fef8d51b.svg";